import { ScopeCalculationObjectType } from '../schema/ScopeCalculationObjectType';

export const isRecurrenceMaster = ({
    CalendarItemType,
}: ScopeCalculationObjectType = {}): boolean => CalendarItemType === 'RecurringMaster';
